// The hook every screen should ask before rendering an action.
//
//   const { can } = usePermissions();
//   {can('inventory', 'delete') && <DeleteButton />}
//
// Hiding a button is not a security control — the database refuses the write
// regardless, which is the point of putting the matrix in RLS rather than in
// the UI. This is about not offering people work that will fail.

import { useMemo } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { can as canClaim, canAny as canAnyClaim } from '@/lib/claims';

export function usePermissions() {
  const { claims } = useAuth();

  return useMemo(
    () => ({
      claims,
      /** `can('reports', 'export')` */
      can: (module: string, action: string) => canClaim(claims, module, action),
      /** Any permission at all on a module — for showing a nav entry. */
      canAny: (module: string) => canAnyClaim(claims, module),
      roleId: claims.roleId,
      /** 0 when this role approves nothing. */
      approvalLevel: claims.approvalLevel,
      isApprover: claims.approvalLevel > 0,
      scopeLimited: claims.scopeLimited,
      rayonId: claims.rayonId,
    }),
    [claims],
  );
}
